<template>
  <div class="iol-usage" v-if="dataLoaded">

    <div class="top">
      <chart-item class='chart-summary' :data="report" :isLink="false" :colorOverride="'#2E96D6'" />
      <chart-item-filter v-if="showIolFilter(0)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[0]"
        @input="iolFilterChanged(0)"
      />
      <chart-item v-if="subReports[0].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#DF5B96'"
        :data="subReports[0].report"
        @close="iolFilterClosed(subReports[0].report.name)"
      />
      <chart-item-filter v-if="showIolFilter(1)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[1]"
        @input="iolFilterChanged(1)"
      />
      <chart-item v-if="subReports[1].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F2C94C'"
        :data="subReports[1].report"
        @close="iolFilterClosed(subReports[1].report.name)"
      />
      <chart-item-filter v-if="showIolFilter(2)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[2]"
        @input="iolFilterChanged(2)"
      />
      <chart-item v-if="subReports[2].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F09639'"
        :data="subReports[2].report"
        @close="iolFilterClosed(subReports[2].report.name)"
      />
      <div class="chart-actions">
        <div class="chart-dropdown">
          <select-field
            v-model="currentChart"
            placeholder="View data by">
            <option v-for="option in chartTypes" :value="option" :key="option.label">{{option.name}}</option>
          </select-field>
        </div>
        <div class="filter" v-if="false">
          <rp-dropdown
            v-model="dateSelected"
            :data-model="dates"
            disable-search
            placeholder="Select year"
            tempIdentifier="Time"
            iconText="Show data from:"
            @input="getReports"
          />
        </div>
      </div>
    </div>

    <div class="chart-main">
      <Bar v-if="this.currentChart && this.currentChart.value=='BarChart'"
        id="bar-satisfaction"
        :chart-data="barChartData"
        :chart-options="barChartOptions"
        :height="300"
      />
      <LineChartGenerator v-if="this.currentChart && this.currentChart.value=='LineChart'"
        id="line-satisfaction"
        :chart-data="lineChartData"
        :chart-options="lineChartOptions"
        :height="300"
      />
    </div>

  </div>
</template>

<script>
  import ChartItem from '../ChartItem_v2'
  import ChartItemFilter from '../ChartItemFilter_v2'
  import SelectField from 'raypro_ui/src/components/ui/inputs/StyledSelect'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'
  import Dropdown from 'raypro_ui/src/components/ui/inputs/dropdown/Dropdown'
  import breakdown from '../../../../mixins/breakdown'
  // Chart.js
  import {Bar, Line as LineChartGenerator} from 'vue-chartjs/legacy'
  import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement} from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, CategoryScale, LinearScale, PointElement)

  export default {
    mixins: [breakdown],

    components: {
      Bar,
      LineChartGenerator,
      ChartItem,
      ChartItemFilter,
      RpSprite, 
      SelectField, 
      'rp-dropdown': Dropdown,
    },

    data() {
      return {
        report: {report_datas: {data: {}}},
        subReports: [
          {report: null, filter: '', color: '#DF5B96'},
          {report: null, filter: '', color: '#F2C94C'},
          {report: null, filter: '', color: '#F09639'},
        ],
        chartTypes: [
          {name: 'Score distribution', value: 'BarChart'},
          {name: 'Time period', value: 'LineChart'},
        ],
        currentChart: {name: 'Time period', value: 'LineChart'},
        barChartData: {
          datasets: [
            {label: 'IOL usage', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: []}
          ]
        },
        lineChartData: {
          datasets: [
            {label: 'IOL usage', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: []}
          ]
        },
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              title: {
                display: true,
                text: 'Month'
              },
              grid: {
                display: true,
              },
            },
            y: {
              title: {
                display: true,
                text: 'IOLs Implanted'
              },
              ticks: {
                precision: 0,
              },
              grid: {
                display: false,
              },
            },
          },
        },
        lineChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false,
            },
          },
          scales: {
            x: {
              title: {
                text: 'Month',
                display: true,
              },
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              title: {
                display: true,
                text: 'IOLs Implanted',
              },
              ticks: {
                precision: 0,
              },
            },
          },
        },
      }
    },

    methods: {
      async getReports() {
        this.report = await this.getReportByIdPromise(this.filterParams)
        this.barChartData.datasets[0].data = this.getTimesForReport(this.report)
        this.lineChartData.datasets[0].data = this.getTimesForReport(this.report)

        this.getSubReports()
        this.dataLoaded = true
      },

      async getSubReports() {
        const models = this.getModelNamesFromFilterParams()
        for (const model of models) {
          let index = 0
          const filterItem = this.iolFilters.find(x => x && x.model === model)
          if (filterItem) {
            index = this.iolFilters.indexOf(filterItem)
          }

          const filterParams = this.getSubReportFilterParams(models.indexOf(model))
          let report = await this.getReportByIdPromise(filterParams)
          report.name = model
          this.subReports[index].report = report
          this.subReports[index].filter = filterParams
        }

        this.renderSubReports()
      },

      renderSubReports() {
        this.barChartData.datasets = this.barChartData.datasets.slice(0, 1)
        this.lineChartData.datasets = this.lineChartData.datasets.slice(0, 1)
        for (var i = 0; i < 3; i++) {
          if (this.subReports[i].report) {
            this.barChartData.datasets.push({
              label: this.subReports[i].report.name,
              borderColor: this.subReports[i].color,
              backgroundColor: this.subReports[i].color,
              data: this.getTimesForReport(this.subReports[i].report)
            })
            this.lineChartData.datasets.push({
              label: this.subReports[i].report.name,
              borderColor: this.subReports[i].color,
              backgroundColor: this.subReports[i].color,
              data: this.getTimesForReport(this.subReports[i].report)
            })
          }
        }
      },

      updateSubReports() {
        this.subReports.forEach((subReport) => {
          if (subReport.report && !this.iolFilters.find((x) => x && x.model === subReport.report.name)) {
            subReport.filter = ''
            subReport.report = null
          }
        })
      },

      downloadReport() {
        this.getExportReportPromise(this.$route.params.report_id, this.report.slug).then((res) => {
          this.downloadResult(res)
        })
      },

      setDownloadOptions() {
        this.$emit('setDownloadOptions', ['IOL Usage'])
      },

      iolFilterChanged(index) {
        if (this.iolFilters[index]) {
          if (this.iolFilters[index] && !this.subReports.find(x => x.report && x.report.name === this.iolFilters[index].model)) {
            this.$emit('addIolFilter', this.iolFilters[index].id)
          } else {
            this.iolFilters[index] = null
          }
        }
      },

      iolFilterClosed(model) {
        const iol = this.iolFilters.find((x) => x && x.model === model)
        this.subReports[this.iolFilters.indexOf(iol)].filter = ''
        this.subReports[this.iolFilters.indexOf(iol)].report = null
        this.iolFilters[this.iolFilters.indexOf(iol)] = null
        this.$emit('removeIolFilter', iol.id)
      },
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .iol-usage
    display: flex
    flex-direction: column
    width: 100%
    min-width: 768px    
    padding: 10px
    margin-right: -30px
    box-shadow: $color-shadow
    background-color: transparent

    .chart-main
      width: 100%
      border-radius: 20px
      background-color: $color-panel-bg

    .top
      display: flex
      flex-direction: column
      justify-content: flex-start
      width: 100%
      gap: 40px
      
      @include media($media-small)
        flex-direction: row

      .chart-summary
        margin-right: 0px

      .chart-actions
        display: none
        position: absolute

        @include media($media-small)
          align-items: center

        .chart-dropdown
          width: 120px

</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/Breakdowns/IolUsage_v2.vue